import {
    Search,
    Funnel,
    Edit2,
    Plus,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    SquareArrowOutUpRight,
    CircleCheck,
    ChevronUp, ChevronDown,
    FunnelPlus
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect, useMemo } from 'react';
import noImage from '../assets/img/brand/noImage.png';
import ConfirmDeactivateModal from './ConfirmDeactivateModal';
import ConfirmArchiveModal from './ConfirmArchiveModal';
import AlertNotification from './AlertNotification';
import apiHelper from '../apiHelper';
import { formatDateTime } from '../utils/formateDate';

const BrandInfoDrawer = ({
  selectedRow,
  setSelectedRow,
  setBrandDrawerOpen,
  setSpuDrawerOpen,
  brandsData,
  setBrandsData,
  readOnly = false,
}) => {
    const history = useHistory();
    const toolbarRef = useRef(null);
    const drawerRef = useRef(null);
    const archivedRef = useRef(null);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [drawerTab, setDrawerTab] = useState('general');
    // const [brandsData, setBrandsData] = useState(brandsData);
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
    const [selectedBrandId, setSelectedBrandId] = useState(null);
    const [spuLinkedModalOpen, setSpuLinkedModalOpen] = useState(false);
    const [linkedModalMessage, setLinkedModalMessage] = useState("");
    const [previousBrand, setPreviousBrand] = useState(null);
    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(prev => !prev);
    };

    const pageData = brandsData;

    const isBrandNameOverflowing = (brandName) => {
        if (!brandName) return false;
        // Consider category name lengthy if it's more than 30 characters
        return brandName.length > 30;
    };    

    const handleCopy = async (textToCopy) => {
        if (!textToCopy) {
            console.error('No text to copy');
            alert('Failed to copy: No text available.');
            return;
        }

        // Use Clipboard API if available and secure
        if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            try {
                await navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            } catch (err) {
                console.error('Clipboard API failed:', err);
                fallbackCopyTextToClipboard(textToCopy);
            }
        } else {
            console.warn('Clipboard API not available or not in secure context, using fallback');
            fallbackCopyTextToClipboard(textToCopy);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                console.error('Fallback copy failed');
                alert('Failed to copy text. Please copy manually.');
            }
        } catch (err) {
            console.error('Fallback copy error:', err);
            alert('Failed to copy text. Please copy manually.');
        }
    };

    const handleDeactivateBrand = async (brandId) => {
        console.log('Deactivating brand ID:', brandId);
        if (!brandId) return;
        console.log('Deactivating brand ID:', brandId);
        try {
            const response = await apiHelper(`inventory/brands/${brandId}/deactivate/`, 'POST');
            if (response.ok) {
                const data = await response.json();
                const isActive = data.status;
                const newStatusText = isActive ? "Active" : "Inactive";
                setSuccessMessage(data.detail || 'Status updated successfully.');
                setBrandsData(prev =>
                    prev.map(brand =>
                        brand.brand_id === brandId
                            ? { ...brand, status: isActive, status_text: newStatusText }
                            : brand
                    )
                );
                // ✅ also update selectedRow if it's the same branch
                setSelectedRow(prev =>
                    prev && prev.brand_id === brandId
                        ? { ...prev, status: isActive, status_text: newStatusText }
                        : prev
                );
                // setDropdownOpenId(null);
                setDeactivateModalOpen(false);
            } else {
                const error = await response.json();
                console.error("Error toggling brand status:", error);
                setDeactivateModalOpen(false);
            }
        } catch (err) {
            console.error("Network/server error while toggling brand status:", err);
        }
    };

    const handleArchivedConfirm = async (brandId) => {
        if (!brandId) return;
    
        try {
            const response = await apiHelper(`inventory/brands/${brandId}/archive/`, 'POST');
            if (response.ok) {
                const data = await response.json();
                setSuccessMessage(data.detail || 'Brand Archived Successfully');
                
                // Get the brand name before removing it
                const archivedBrandName = brandsData.find(brand => brand.brand_id === brandId)?.brand_name;
                
                // 1. Remove the archived brand
                /*setBrandsData(prev => prev.filter(brand => brand.brand_id !== brandId));
                
                // 2. Update all child brands to remove the archived parent reference
                setBrandsData(prev => prev.map(brand => {
                    if (brand.parent_name === archivedBrandName) {
                        return {
                            ...brand,
                            parent_name: null,
                            parent_brand: null,
                            parent_brand_name: null
                        };
                    }
                    return brand;
                }));*/
    
                // 4. Update the selected row if it's a child of the archived brand
                // if (selectedRow && selectedRow.parent_name === archivedBrandName) {
                //     setSelectedRow(prev => ({
                //         ...prev,
                //         parent_name: null,
                //         parent_brand: null,
                //         parent_brand_name: null
                //     }));
                // }
    
                // 5. Update pageData (filtered brands) to reflect changes
                // This will happen automatically when brandsData updates and filtered recomputes
                
                // fetchArchivedBrands();
                // setDrawerOpen(false);
            } else if (response.status === 400) {
                const response_errors = await response.json();
    
                if (response_errors.detail === "Cannot archive this brand. SPUs are linked to it.") {
                    setSpuLinkedModalOpen(true);
                    setLinkedModalMessage("This brand can't be archived because it's referenced by one or more SPUs. Please remove or reassign those SPUs before archiving.");
                } else if(response_errors.detail === "Cannot archive this brand. other brands are linked to it.") {
                    setSpuLinkedModalOpen(true);
                    setLinkedModalMessage(response_errors.detail);
                } else {
                    let errors = [];
                    for (let i in response_errors) {
                        errors.push(`${i}: ${response_errors[i][0]}`);
                    }
                    // setValidationError(errors);
                    setSuccessMessage('');
                }
            }
        } catch (error) {
            console.error("Error archiving brand:", error);
            setSuccessMessage('');
        }
        setArchivedModalOpen(false);
    };

    const openArchiveModal = (brandId) => {
        setSelectedBrandId(brandId);
        setArchivedModalOpen(true);

    };

    const handleParentBrandClick = (parentBrandId) => {
        if (parentBrandId) {
            setPreviousBrand(selectedRow);

            // Find the parent brand in the data
            const parentBrand = brandsData.find(brand => brand.brand_id === parentBrandId);
            if (parentBrand) {
                setSelectedRow(parentBrand);
                setDrawerTab('general');
                // setDrawerOpen(true);
            }
        }
    };

  return (
    <>
        <div
            className="drawer-overlay"
            onMouseDown={(e) => {
                // Outside click returns to the previous (parent) drawer.
                e.stopPropagation();
                setBrandDrawerOpen(false);
            }}
        />
        <div className="entity-drawer" ref={drawerRef}>
            <div className="drawer-header" style={{ backgroundColor: "#F8F9FA" }}>
                <div className="d-flex align-items-center gap-1">
                    
                        <button
                            className="back-btn"
                            onClick={() => { 
                                if(previousBrand) {
                                    setSelectedRow(previousBrand);
                                    setPreviousBrand(null);
                                } else {
                                    setBrandDrawerOpen(false);
                                }
                            }}
                            style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                        >
                            <ChevronLeft size={24} />
                        </button>
                    
                    <h3>Brand Info</h3>
                </div>
                <button
                    className="close-btn"
                    onClick={() => { setBrandDrawerOpen(false); setSpuDrawerOpen(false); }}
                >
                    <X size={18} />
                </button>
            </div>
            <div className="main-drawer-inner">
                <div className="drawer-title d-flex align-items-center justify-content-between"
                    style={{
                        borderBottom: "none",
                        paddingBottom: "0px",
                        boxShadow: "none",
                        marginBottom: "0px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "nowrap",
                        width: "100%",
                    }}
                >
                    <div className='d-flex align-items-center'>
                        <img
                            src={selectedRow.original_logo_url || noImage}
                            alt="avatar"
                            className="avatar"
                            onError={(e) => { e.target.onerror = null; e.target.src = noImage; }}
                            style={{
                                width: 40,
                                height: 40,
                                // borderRadius: '50%',
                                marginRight: 8,
                                verticalAlign: 'middle'
                            }}
                        />
                        <h2 style={{ textTransform: 'none', }} className='pb-0'

                        >{selectedRow?.brand_name}</h2>
                    </div>
                    {!readOnly && <div className='entities-tab'>
                        <div className='toolbar'>
                            <div className='toolbar-right' style={{
                                position: "relative", flexWrap: "nowrap"

                            }} ref={toolbarRef}>
                                <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2'
                                    style={{
                                        flexShrink: 0,              // ✅ prevents collapse
                                        whiteSpace: 'nowrap',       // ✅ keeps buttons inline
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                    }}

                                >
                                    <button
                                        className="dark-border gray-btn"
                                        type='button'
                                        onClick={() => { history.push(`/brand/edit-brand/${selectedRow.brand_id}`); }}
                                        style={{ width: '100px' }}
                                    >
                                        Edit
                                    </button>
                                </div>
                                <button
                                    className="drawer-dots"
                                    style={{ boxShadow: 'none' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleToolbarDropdown();
                                    }}
                                >
                                    <MoreHorizontal size={18} />
                                </button>
                                {toolbarDropdownOpen && (
                                    <div
                                        className="backdrop-cls"
                                        style={{
                                            position: "absolute",
                                            top: 40,
                                            right: 0,
                                            background: "white",
                                            boxShadow: "0px 1px 4px 0px #0000001A",
                                            zIndex: 1000,
                                            minWidth: 152,
                                            borderRadius: 8,
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="btn-align-forall">
                                            <div className="common-for-all">
                                                <button
                                                    onClick={() => {
                                                        if (selectedRow.status_text === 'Active') {
                                                            // Active → show confirmation modal
                                                            setDeactivateModalOpen(true);
                                                            setSelectedBrandId(selectedRow.brand_id);
                                                            // setToolbarDropdownOpen(false);
                                                        } else {
                                                            // Inactive → activate directly
                                                            handleDeactivateBrand(selectedRow.brand_id);
                                                            setToolbarDropdownOpen(false);
                                                        }
                                                        setToolbarDropdownOpen(false);
                                                    }}
                                                >
                                                    {selectedRow.status_text === 'Active' ? 'Deactivate' : 'Activate'} 
                                                </button>
                                            </div>
                                            <div className="common-for-all">
                                                <button
                                                    onClick={() => {
                                                        const row = pageData.find(d => d.brand_id === selectedRow.brand_id);
                                                        console.log(pageData);
                                                        if (row) {
                                                            openArchiveModal(row.brand_id);
                                                            setToolbarDropdownOpen(false);
                                                        } else {
                                                            console.warn('Row not found for brand_id:', selectedRow.brand_id);
                                                        }
                                                    }}
                                                    className="deactivate-cls"
                                                >
                                                    Archive
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>}
                </div>
                <div className="drawer-tabs"
                    style={{
                        padding: " 20px",           // optional: top/bottom 0, left/right 20px
                        borderBottom: "1px solid #E9ECEF",
                        gap: "20px",
                        marginBottom: "20px",
                    }}

                >
                    <button
                        className={drawerTab === 'general' ? 'active' : ''}
                        onClick={() => setDrawerTab('general')}
                    >
                        General
                    </button>
                    <button
                        className={drawerTab === 'additional-info' ? 'active' : ''}
                        onClick={() => setDrawerTab('additional-info')}
                    >
                        Additional
                    </button>
                </div>
                <div className="drawer-content">
                    {drawerTab === 'general' && (
                        <div className="tab-panel general-panel">

                            {/* ===== BASIC INFO CARD ===== */}
                            <div
                                className="card-section"
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // subtle elevation
                                    overflow: 'hidden',
                                    marginBottom: '20px',
                                    marginTop: '20px',
                                }}
                            >
                                {/* HEADER */}
                                <div
                                    className="card-header"
                                    style={{
                                        backgroundColor: ' #F8F9FA',
                                        padding: '15px 20px',
                                        fontFamily: 'Montserrat',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        color: ' #212529',
                                        display: 'flex',
                                        alignItems: 'center',
                                        alignSelf: 'stretch',
                                        borderRadius: '12px 12px 0px 0px',
                                        gap: '10px',
                                        height: '50px',
                                    }}
                                >
                                    Basic Info
                                </div>

                                {/* BODY */}
                                <div
                                    className="card-body"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        padding: '16px',
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(2, 1fr)',
                                        gap: '16px',
                                    }}
                                >
                                    {/* <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                        <div className="field-label">Brand Name</div>
                                        <div className="field-value">{selectedRow.brand_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>

                                    <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                        <div className="field-label">Status</div>
                                        <div className="field-value">
                                            <span className={`status ${selectedRow.status_text?.toLowerCase()}`}>
                                                {selectedRow.status_text || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </span>
                                        </div>
                                    </div> */}

                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        minHeight: '60px',
                                        gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1 / -1' : '1',
                                        gridRow: '1'
                                    }}>
                                        <div className="field-label">Brand Name</div>
                                        <div className="field-value" style={{
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word',
                                            whiteSpace: 'normal'
                                        }}>
                                            {selectedRow.brand_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                        </div>
                                    </div>

                                    {/* Status Field - Position depends on Category Name length */}
                                    <div className="field-block" style={{
                                        borderBottom: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        minHeight: '60px',
                                        gridColumn: isBrandNameOverflowing(selectedRow.brand_name) ? '1' : '2',
                                        gridRow: isBrandNameOverflowing(selectedRow.brand_name) ? '2' : '1'
                                    }}>
                                        <div className="field-label">Status</div>
                                        <div className="field-value">
                                            <span className={`status ${typeof selectedRow?.status_text === 'string' ? selectedRow.status_text?.toLowerCase() : ''}`}>
                                                {selectedRow.status_text || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className="field-block"
                                        style={{
                                            borderBottom: 'none',
                                            padding: '9px 0',
                                            gridColumn: '1 / -1', // ✅ span both columns
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            width: '100%',
                                        }}>
                                        <div className="field-label" style={{ marginBottom: '4px' }}>ID</div>
                                        <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                            {selectedRow.external_id || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                        </div>
                                    </div>

                                    <div
                                        className="field-block"
                                        style={{
                                            borderBottom: 'none',
                                            padding: '9px 0',
                                            gridColumn: '1 / -1', // ✅ span both columns
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            width: '100%',
                                        }}
                                    >
                                        <div className="field-label" style={{ marginBottom: '4px' }}>Open ID</div>
                                        <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                            {selectedRow.uuid ? (
                                                <div className="field-value d-flex align-items-center gap-2">
                                                    <span
                                                        style={{
                                                            color: '#2C7BE5',
                                                            cursor: 'pointer',
                                                            textDecoration: 'underline',
                                                        }}
                                                        onClick={() => handleCopy(selectedRow.uuid)}
                                                    >
                                                        {selectedRow.uuid}
                                                        <Copy
                                                            size={13}
                                                            onClick={() => handleCopy(selectedRow.uuid)}
                                                            style={{ cursor: 'pointer', color: '#2C7BE5', marginLeft: '6px', }}
                                                        />
                                                    </span>
                                                    {copied && (
                                                        <span style={{ fontSize: '12px', color: '#2C7BE5' }}>
                                                            Copied!
                                                        </span>
                                                    )}
                                                </div>
                                            ) : (
                                                <span style={{ color: '#ADB5BD' }}>NA</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                        <div className="field-label">Created By</div>
                                        <div className="field-value">{selectedRow.created_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>

                                    <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                        <div className="field-label">Created Time</div>
                                        <div className="field-value">
                                            {formatDateTime(selectedRow.created_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                        </div>
                                    </div>

                                    <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                        <div className="field-label">Last Modified By</div>
                                        <div className="field-value">
                                            {selectedRow.modified_by_name || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                        </div>
                                    </div>

                                    <div className="field-block" style={{ borderBottom: 'none', padding: "9px 0px " }}>
                                        <div className="field-label">Last Modified Time</div>
                                        <div className="field-value">
                                            {formatDateTime(selectedRow.modified_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ===== BUSINESS INFO CARD ===== */}
                            <div
                                className="card-section"
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                    overflow: 'hidden',
                                }}
                            >
                                <div
                                    className="card-header"
                                    style={{
                                        backgroundColor: '#F8F9FA',
                                        padding: '10px 16px',
                                        fontFamily: 'Montserrat',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        color: '#212529',
                                    }}
                                >
                                    Business Info
                                </div>

                                <div
                                    className="card-body"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        padding: '16px',
                                        display: 'grid',
                                        gridTemplateColumns: 'minmax(150px, 1fr) 1fr', // ✅ flexible first column
                                        gap: '16px',
                                        wordBreak: 'break-word',       // ✅ forces long words to break
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'normal',
                                    }}
                                >
                                    <div className="field-block"
                                        style={{
                                            borderBottom: 'none',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            minHeight: '60px',
                                            gridColumn: isBrandNameOverflowing(selectedRow.parent_name) ? '1 / -1' : '1',
                                            gridRow: '1',
                                            padding: '9px 0px',
                                        }}
                                    >
                                        <div className="field-label">Parent Brand</div>
                                        <div className="field-value">
                                            {selectedRow.parent_name && selectedRow.parent_name !== <span style={{ color: '#ADB5BD' }}>NA</span> ? (
                                                (() => {
                                                    const parentBrandObj = brandsData.find(
                                                        (d) => d.brand_id === selectedRow.parent_brand
                                                    );
                                                    const parentLogo =
                                                        parentBrandObj?.original_logo_url || noImage;

                                                    return (
                                                        <div className="d-flex align-items-center" >
                                                            <img
                                                                src={parentLogo}
                                                                alt="parent brand logo"
                                                                className="avatar"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = noImage;
                                                                }}
                                                                style={{
                                                                    width: 32,
                                                                    height: 32,
                                                                    marginRight: 10,
                                                                    flexShrink: 0,
                                                                    verticalAlign: 'middle',
                                                                }}
                                                            />
                                                                {parentBrandObj?.status ? (

                                                            <div
                                                                className="me-3"
                                                                style={{
                                                                    color: '#2C7BE5',
                                                                    textDecoration: 'underline',
                                                                    fontWeight: 600,
                                                                    fontSize: '12px',
                                                                    cursor: 'pointer',
                                                                    lineHeight: '1.4',
                                                                    maxWidth: '100%',
                                                                    wordBreak: 'break-word',
                                                                    overflowWrap: 'anywhere',
                                                                    whiteSpace: 'normal',

                                                                }}
                                                                onClick={() => {
                                                                    if (parentBrandObj) {
                                                                        handleParentBrandClick(parentBrandObj?.brand_id);
                                                                    } else {
                                                                        console.warn('Parent brand not found in brandsData');
                                                                    }
                                                                }}
                                                            >
                                                                {/* ✅ text and icon in same inline flow */}
                                                                <span style={{ display: 'inline', wordBreak: 'break-word' }}>
                                                                    {selectedRow.parent_name}

                                                                        <SquareArrowOutUpRight
                                                                            size={14}
                                                                            strokeWidth={3}
                                                                            style={{
                                                                                marginLeft: '4px',
                                                                                verticalAlign: 'text-top', // ✅ aligns nicely with text
                                                                                color: '#2C7BE5',
                                                                            }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                if (parentBrandObj) {
                                                                                    // handleParentBrandClick(parentBrandObj.brand_id);
                                                                                } else {
                                                                                    console.warn('Parent brand not found in brandsData');
                                                                                }
                                                                            }}
                                                                        />
                                                                </span>
                                                            </div>
                                                                    ) : <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                        </div>



                                                    );
                                                })()
                                            ) : (
                                                <span style={{ color: '#ADB5BD' }}>NA</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="field-block"
                                        style={{
                                            borderBottom: 'none',
                                            padding: '9px 0px',
                                            wordBreak: 'break-word',       // ✅ added
                                            overflowWrap: 'break-word',
                                            whiteSpace: 'normal',
                                        }}

                                    >
                                        <div className="field-label">Prefix</div>
                                        <div className="field-value">{selectedRow.prefix || <span style={{ color: '#ADB5BD' }}>NA</span>}</div>
                                    </div>

                                    <div
                                        className="field-block"
                                        style={{
                                            borderBottom: 'none',
                                            padding: '9px 0',
                                            gridColumn: '1 / -1', // ✅ span both columns
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                            width: '100%',
                                        }}>
                                        <div className="field-label" style={{ marginBottom: '4px' }}>Logo</div>
                                        <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                            <img
                                                src={selectedRow.original_logo_url || noImage}
                                                alt="avatar"
                                                className="avatar"
                                                onError={(e) => { e.target.onerror = null; e.target.src = noImage; }}
                                                style={{
                                                    // maxWidth: 100,
                                                    cursor: 'pointer',
                                                    // borderRadius: '8px',
                                                    width: 32,
                                                    height: 32
                                                }}
                                                onClick={() => setImageModalOpen(true)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {imageModalOpen && (
                        <>
                            <div className="drawer-overlay" style={{ zIndex: 1100 }} />
                            <div
                                className="image-modal"
                                style={{
                                    position: 'fixed',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    background: 'white',
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                    zIndex: 1101,
                                    maxWidth: '90%',
                                    maxHeight: '90%',
                                    overflow: 'auto'
                                }}
                            >
                                <div style={{ position: 'relative' }}>
                                    <button
                                        className="close-btn"
                                        onClick={() => setImageModalOpen(false)}
                                        style={{
                                            position: 'absolute',
                                            top: '10px',
                                            right: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <X size={24} />
                                    </button>
                                    <img
                                        src={selectedRow.original_logo_url || noImage}
                                        alt="avatar"
                                        onError={(e) => { e.target.onerror = null; e.target.src = noImage; }}
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '80vh',
                                            display: 'block'
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {drawerTab === 'additional-info' && (
                        <div
                            className="card-section"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                overflow: 'hidden',
                                marginTop: '40px',
                            }}
                        >
                            {/* ✅ Header: same style as Business Info */}
                            <div
                                className="card-header "
                                style={{
                                    backgroundColor: '#F8F9FA',
                                    padding: '10px 16px',
                                    fontFamily: 'Montserrat',
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    color: '#212529',
                                }}
                            >
                                Notes
                            </div>

                            {/* ✅ Body: matches layout and spacing */}
                            <div
                                className="card-body"
                                style={{
                                    backgroundColor: '#FFFFFF',
                                    padding: '16px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px',
                                    wordBreak: 'break-word',
                                    overflowWrap: 'break-word',
                                    whiteSpace: 'normal',
                                }}
                            >
                                <div className="field-block">
                                    <div
                                        className="field-value notes-preserve"
                                        style={{
                                            background: '#FFFFFF',
                                            padding: '8px 0',
                                            fontSize: '13px',
                                            color: selectedRow.notes ? '#212529' : '#ADB5BD',
                                            minHeight: '24px',
                                        }}
                                    >
                                        {selectedRow.notes || 'NA'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                </div>
            </div>
        </div>
        {successMessage && (
            <AlertNotification
                type="success"
                recordName="Brand"
                action={
                    successMessage.includes("Archived")
                        ? "archive"
                        : successMessage.includes("Discarded")
                            ? "discard"
                            : successMessage.includes("Activated")
                                ? "activate"
                                : successMessage.includes("Deactivated")
                                    ? "deactivate"
                                    : "create"
                }
                onClose={() => setSuccessMessage("")}
            />
        )}
        {deactivateModalOpen && (
            <ConfirmDeactivateModal
                isOpen={deactivateModalOpen}
                onCancel={() => setDeactivateModalOpen(false)}
                onConfirm={() => {
                    handleDeactivateBrand(selectedBrandId);
                    // setDeactivateModalOpen(false);
                }}
                entityName="Brand"
            />
        )}
        {archivedModalOpen && (
            <ConfirmArchiveModal
                isOpen={archivedModalOpen}
                onCancel={() => setArchivedModalOpen(false)}
                onConfirm={() => handleArchivedConfirm(selectedBrandId)} // ✅ confirm action
                entityName="Brand"
            />
        )}
        {spuLinkedModalOpen && (
            <>
                <div className="drawer-overlay" />
                <div
                    className="entity-drawer modal-popup-cls"
                    ref={archivedRef}
                    style={{
                        maxWidth: 650,
                        margin: "0 auto",
                        background: "white",
                        borderRadius: 12,
                        zIndex: 1050,
                        padding: 24,
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        height: "auto",
                        right: "auto",
                        overflow: "inherit",
                    }}
                >
                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                        <button className="close-btn" onClick={() => setSpuLinkedModalOpen(false)}>
                            <X size={20} />
                        </button>
                    </div>
                    <h3
                        style={{
                            textAlign: "left",
                            color: "#212529",
                            fontSize: "20px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            fontFamily: "Montserrat",
                            marginBottom: "5px",
                        }}
                    >
                        The brand can't be archived
                    </h3>
                    <p
                        style={{
                            marginBottom: "0",
                            textAlign: "left",
                            color: "#6C757D",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Montserrat",
                        }}
                    >
                        {linkedModalMessage}
                    </p>
                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                        <button className="btn-save" onClick={() => setSpuLinkedModalOpen(false)}>
                            OK
                        </button>
                    </div>
                </div>
            </>
        )}
    </>
  );
};

export default BrandInfoDrawer;